import React, { useState, useEffect } from "react";
import { getDocs, collection } from "firebase/firestore";
import { db, auth } from "../../firebase";
import Tnpnav from "./Tnpnav";
export default function Companydetails(prop) {
  const [joblist, setJoblist] = useState([]);

  const ref = collection(db, "Industry");
  useEffect(() => {
    const getjob = async () => {
      const data = await getDocs(ref);
      setJoblist(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getjob();
  },[]);
  return (
    <>
    <Tnpnav/>

    <table className="tnptable" id="stuTable">
        <thead>
          <tr>
  
            <th>Company name</th>
            <th>Comapany Email</th>
            
          </tr>
        </thead>
      {joblist.map((post) => {
        return (
           <>
            <tbody>
                      <tr>
                      <td>{post.name}</td>
            <td>{post.email}</td>
                      </tr>
                    </tbody>
            
            <br/>
            </>
        );
      })}
      </table>
   
    </>
  );
}
